import { render, staticRenderFns } from "./admin.location.page.vue?vue&type=template&id=c1c36f04&scoped=true&"
import script from "./admin.location.page.vue?vue&type=script&lang=js&"
export * from "./admin.location.page.vue?vue&type=script&lang=js&"
import style0 from "./admin.location.page.vue?vue&type=style&index=0&id=c1c36f04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1c36f04",
  null
  
)

export default component.exports